import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { Link, useParams } from "react-router-dom";
import { Col } from "react-bootstrap";
import { getroom } from "../store/slices/roomType";
import ShowSkeleton from "../utils/helpers/skeleton";

const Rooms = () => {
  const { id } = useParams();
  console.log(id);
  const [data, setData] = useState([]);
  const [isloading, setisLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setisLoading(true);
    getRoomLists();
  }, []);

  const getRoomLists = () => {
    const hotelId = id;
    let item = { hotelId };
    dispatch(getroom(item))
      .unwrap()
      .then((data) => {
        setData(data?.roomTypeData);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Rooms</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Rooms</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
          <Link
            to={`/admin/add-room/${id}`}
            className="btn btn-primary text-md btn-sm px-8 py-8 text-sm radius-8 d-flex align-items-center gap-2"
          >
            Add Room
          </Link>
        </div>
        <div className="card-body px-24 py-2">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-50">
                <thead>
                  <tr>
                    <th scope="col">Room Type</th>
                    <th scope="col" className="text-center">
                      Price
                    </th>

                    <th scope="col" className="text-center">
                      Total Rooms
                    </th>
                    <th scope="col" className="text-center">
                      Status
                    </th>
                    <th scope="col" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center flex-grow-1">
                            <img
                              src={item?.images[0]?.mediaLink}
                              alt=""
                              className="me-2"
                              style={{
                                width: "70px",
                                borderRadius: "10px",
                              }}
                            />
                            <span className="text-md mb-0 fw-normal text-secondary-light ms-2">
                              {item?.roomTypeId?.name}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item?.pricePerRoom}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item.availableRoomCount}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="text-center">
                        {item.status === "sold out" && (
                          <Link
                            className="text-md bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium d-flex justify-content-center align-items-center"
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "90px",
                            }}
                          >
                            Sold Out
                          </Link>
                        )}
                        {item.status === "available" && (
                          <Link
                            className="text-md bg-success-focus text-success-600 bg-hover-success-200 fw-medium justify-content-center align-items-center"
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "80px",
                            }}
                          >
                            Available
                          </Link>
                        )}
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <Link
                            to={`/admin/edit-room/${item._id}/${item.hotelId._id}`}
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                            }}
                            className="text-md bg-warning-focus text-warning-600 bg-hover-warning-200 fw-medium justify-content-center align-items-center"
                          >
                            Edit
                          </Link>

                          <Link
                            to={`/admin/copy-room/${item._id}/${item.hotelId._id}`}
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                            }}
                            className="text-md bg-info-focus text-info-600 bg-hover-info-200 fw-medium justify-content-center align-items-center"
                          >
                            Copy
                          </Link>

                          <Link
                            to={`/admin/room-availability/${item._id}`}
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "90px",
                            }}
                            className="text-md bg-success-focus text-success-600 bg-hover-success-200 fw-medium justify-content-center align-items-center"
                          >
                            Availabilty
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Rooms;
